module.exports = __webpack_public_path__ + "assets/8247d55183a8751894bcc15d79987b50.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level5_Hit17s.mp3
 ** module id = 251
 ** module chunks = 0
 **/